<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Protein Annotations</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p> There are <span style="color:red;font-weight: bold;">{{samples_data.length}} </span> proteins annotated. We used <span style="color:red;font-weight: bold;">PFAM,VOGdb,eggNOG</span> as the sources for annotation. The functional affiliation for each protein cluster were mapped based on its members affiliation only if <span style="color:red;font-weight: bold;">> 75%</span> were consistent.the Protein cluster with no annotation from these three source blast to the RefSeq proteins with <span style="color:red;font-weight: bold;">hmmsearch</span>.</p>
                    <ul>
                        <li><download-csv
                            :data   = "samples_data" style="cursor: pointer;">
                        To download the table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></li>
                        <li>To download the HMM profiles for the annotations: <a href="file/MGEs_PC.zip" target="_blank"><font-awesome-icon icon="download" ></font-awesome-icon></a></li>
                    </ul>
                    <p>
                        <b>Table notes:</b><br>
                        <ul>
                            <li>Protein family ID: Auto generated ID for each protein cluster</li>
                            <li>Frequency:The mumber of eMGEs that contain this protein family</li>
                            <li>Phage frequency:The number of phage contigs having this protein family</li>
                            <li>Plasmid frequency:The number of plasmid contigs having this protein family</li>
                        </ul>
                    </p>
                </b-col>
            </b-row>
            <b-card  align="left">
                <b-card-body>
                    <b-row style="margin-top:10px;margin-bottom:10px">
                            <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="filter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                    </b-row>
                    <b-row>
                        <p><download-csv
                            :data   = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                    </b-row>
                    <!-- <b-row style="align:left">
                        <b-col>
                           <b-form-group 
                            label="Filter options"
                            label-for="filt-input">
                            <b-input-group>
                                <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                            </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{btn}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div>
                            <p>
                                <b>Note:</b>
                                The search box can be used to search Sample RUN ID's and instrument models of the samples only.
                            </p>
                        </b-col>                        
                    </b-row> -->                    
                </b-card-body>    
            </b-card>
            <br/>
            <b-row>
                <b-col align-self="center">
                    <b-table
                        responsive
                        show-empty
                        :busy.sync="samIsBusy"
                        :striped="false"
                        :outlined="true"
                        :items="procSams"
                        :fields="sample_fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :filter-function="filterTable"
                    >
                        <template  v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                        </template>
                        <template v-slot:cell(NCBI_Run_ID) ="row">
                                <router-link :to="{ path: '/viewsample/'+row.item.NCBI_Run_ID}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.NCBI_Run_ID}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                                <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.NCBI_Run_ID" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge>
                        </template>
                        <template v-slot:cell(ProteinID) ="row">
                                <router-link :to="{ path: '/viewprotcluster/'+row.item.ProteinID}" target="_blank" v-b-tooltip.hover title="View Protein cluster details in our database">{{row.item.ProteinID}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link>
                        </template>
                        <template v-slot:cell(geo_location)="row">
                            Long:{{row.item.GeoLongitude}},Lat:{{row.item.GeoLatitude}}
                        </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="procSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import { saveAs } from 'file-saver';
const FileSaver = require('file-saver');

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:false,
            filter:null,
            samIsBusy:true,
            samples_data:[],
            sample_fields:[
                { key:'ProteinID',label:'Protein family ID',sortable:false,'class': 'medium_col' },
                { key: 'function', label: 'Function', sortable: false},
                { key: 'protein_number', label: 'Protein number', sortable: true},
                { key: 'frequency', label: 'Frequency', sortable: true},
                { key: 'phage_frequency', label: 'Phage frequency', sortable: true},
                { key: 'plasmid_frequency', label: 'Plasmid frequency', sortable: true},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            filtMod:'BodySite',
            filtTerm:'',
            filtOptions:['BodySite','Country','Phenotype','Gender'],
            addedFilters:[],
        }
    },
    mounted() {        
        this.loadTabDat()
        let pcid = this.$route.params.pcid
        if (pcid != undefined){
            this.filter = pcid
        }
    },
    computed: {
        procSams(){
            if(this.samples_data.length){
                let tem = this.samples_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.ProteinID != null && sam.ProteinID.match(sup)) || 
                        (sam.function != null && sam.function.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return null
        },
        procSamsSize(){
            if(this.samples_data.length){
                let tem = this.samples_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.ProteinID != null && sam.ProteinID.match(sup)) || 
                        (sam.function != null && sam.function.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        }
    },
    methods: {
        loadTabDat(){
            axios.post(this.server_add+'query/getPCAnnotate',
            {
            }).then(retDat => {
                if(retDat.status == 200 && retDat.data.length>=1){
                    this.samples_data = retDat.data
                    this.samIsBusy = false
                    this.totalRows = this.samples_data.length
                    this.showPage = true
                }else{
                    console.log('no related data found ')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        addFilter(){
            var filtType = this.filtMod
            var filtText = this.filtTerm
            if(!this.addedFilters.includes(filtType+':'+filtText)){
                this.addedFilters.push(filtType+':'+filtText)
                this.filtTerm = ''
            }
        },
        filterTable(row,filter) {
            var hasAss = false
            var ar = []
            if(filter.includes(row.ProteinID) || filter.includes(row.function) ){
                hasAss = true
            }else{
                if(filter != null ){
                    var su = filter                                        
                    if( (row.ProteinID != null && row.ProteinID.match(su)) 
                    || (row.function != null && row.function.match(su)) ){
                         hasAss = true
                     }
                }
            }                    
            return hasAss;            
        },        
        removeFilter(term){
            var ind = this.addedFilters.indexOf(term)
            if(ind >-1){
                this.addedFilters.splice(ind, 1);
            }
        },
        saveToFile(){
            var file = new File(['file/MGEs_PC.hmm'], "PC_hmm_profile.hmm", {type: "text/plain;charset=utf-8"});
            FileSaver.saveAs(file);
        }
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.listyle{
    display: inline-block;
    border-style: solid;
    margin-left: 5px;
    margin-top: 2px;
    border-width: 1px;
    padding: 0.5em;
    border-color:black;
    text-decoration: none;
    font-size: 15px;
}

.listyle a{
    cursor: pointer;
}
</style>